/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Showcase_Use_Case_Customer_SupportInputs */



/**
* | output |
* | --- |
* | "Support" |
*
* @param {Model_Showcase_Use_Case_Customer_SupportInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_showcase_use_case_customer_support = /** @type {((inputs?: Model_Showcase_Use_Case_Customer_SupportInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Showcase_Use_Case_Customer_SupportInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Support")
	return /** @type {LocalizedString} */ ("Support")
});